
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M28 3.031v9.156c1.156.418 2 1.521 2 2.813s-.844 2.394-2 2.813v9.156l-1.594-1.156s-2.007-1.443-4.875-2.906-6.587-2.906-9.813-2.906H8.343l1.625 5.719.344 1.281H4.249l-.219-.719-2-7-.031-.156v-9.125h9.719c3.27 0 6.987-1.412 9.844-2.875s4.844-2.938 4.844-2.938zM26 6.75c-.82.558-1.459 1.064-3.531 2.125C19.54 10.375 15.743 11.925 12 12v6c3.708.073 7.499 1.595 10.438 3.094 2.078 1.06 2.735 1.567 3.563 2.125V6.75zM4 12v6h6v-6H4zm.344 8l1.406 5h1.906L6.25 20H4.344z"}})])
          )
        }
      }
    